import { typedKeptMessage } from "@/lib/typedAmountKept";   // Step 12 add-on G6.1
// Batch 34 · fork G — EN + AR strings (big-file rule: merged into lib/i18n.js translations with _overrideDeep).
// B34-1 the AI draft button; B34-2 why a final-analytical-review line is / is not highlighted; P51-S5 / S6 / S8 / S9 coded errors.
// No provider names; no standards paragraph numbers.
export const I18N_B34G = {
  en: {
    far: {
      draftOne: "AI draft explanation",                                    // B34-1 (was "Draft explanation")
      thresholds: "Highlight rule: movement more than performance materiality ({pm}) and more than {pct}% of the prior year (both). "
        + "A line that meets only one of the two is not highlighted — point at a line to see why. For information only — nothing is blocked.",
      why: {                                                               // B34-2: the row's tooltip
        above_pm_and_pct: "Highlighted: the movement ({mv}) is above performance materiality ({pm}) and above {pct}% of the prior year ({mvPct}).",
        below_pm: "Not highlighted — below performance materiality: the movement ({mv}) is not above {pm}, although it is above {pct}% ({mvPct}).",
        below_pct: "Not highlighted — below {pct}%: the movement ({mvPct} of the prior year) is not above {pct}%, although it is above performance materiality ({pm}).",
        below_pm_and_pct: "Not highlighted — below performance materiality ({pm}) and below {pct}% of the prior year ({mvPct}).",
        no_prior_year: "Not highlighted — there is no prior-year figure to compare with.",
      },
      amountNotNumber: "The expected amount must be a number (for example 125000.00).",
    },
    b33frs: {
      failed: "The firm report settings could not be saved. Try again.",     // P51-S9 (was an English-only "Failed")
    },
    itemSignoff: {
      notRequiredCheckFailed: "The check for lead sheets with no balance could not be completed — every lead sheet is counted as required for now.",
    },
    errors: {
      FAR_EXPECTATION_NOT_A_NUMBER: "The expected amount must be a number (for example 125000.00).",
      FAR_OVERRIDE_NOT_A_NUMBER: "The expected amount must be a number (for example 125000.00).",
      FIRM_SETTING_TOO_LONG: "The text is too long for this firm setting.",
      LEAD_SHEET_NOT_REQUIRED_CHECK_FAILED: "The check for lead sheets with no balance could not be completed — every lead sheet is counted as required for now.",
    },
  },
  ar: {
    far: {
      draftOne: "صياغة تفسير بالذكاء الاصطناعي",
      thresholds: "قاعدة التمييز: حركة تزيد على الأهمية النسبية للأداء ({pm}) وتزيد على {pct}% من السنة السابقة (الشرطان معًا). "
        + "البند الذي يستوفي شرطًا واحدًا فقط لا يُميَّز — أشِر إلى البند لمعرفة السبب. للعلم فقط — لا يُمنع أي إجراء.",
      why: {
        above_pm_and_pct: "مُميَّز: الحركة ({mv}) تزيد على الأهمية النسبية للأداء ({pm}) وتزيد على {pct}% من السنة السابقة ({mvPct}).",
        below_pm: "غير مُميَّز — أقل من الأهمية النسبية للأداء: الحركة ({mv}) لا تزيد على {pm}، مع أنها تزيد على {pct}% ({mvPct}).",
        below_pct: "غير مُميَّز — أقل من {pct}%: الحركة ({mvPct} من السنة السابقة) لا تزيد على {pct}%، مع أنها تزيد على الأهمية النسبية للأداء ({pm}).",
        below_pm_and_pct: "غير مُميَّز — أقل من الأهمية النسبية للأداء ({pm}) وأقل من {pct}% من السنة السابقة ({mvPct}).",
        no_prior_year: "غير مُميَّز — لا يوجد رقم للسنة السابقة للمقارنة.",
      },
      amountNotNumber: "يجب أن يكون المبلغ المتوقع رقمًا (مثل 125000.00).",
    },
    b33frs: {
      failed: "تعذّر حفظ إعدادات تقرير المكتب. حاول مرة أخرى.",
    },
    itemSignoff: {
      notRequiredCheckFailed: "تعذّر إكمال فحص الأوراق الرئيسية التي لا رصيد لها — تُحتسب كل الأوراق الرئيسية مطلوبة حاليًا.",
    },
    errors: {
      FAR_EXPECTATION_NOT_A_NUMBER: "يجب أن يكون المبلغ المتوقع رقمًا (مثل 125000.00).",
      FAR_OVERRIDE_NOT_A_NUMBER: "يجب أن يكون المبلغ المتوقع رقمًا (مثل 125000.00).",
      FIRM_SETTING_TOO_LONG: "النص أطول من المسموح لهذا الإعداد من إعدادات المكتب.",
      LEAD_SHEET_NOT_REQUIRED_CHECK_FAILED: "تعذّر إكمال فحص الأوراق الرئيسية التي لا رصيد لها — تُحتسب كل الأوراق الرئيسية مطلوبة حاليًا.",
    },
  },
};

// Batch 34 · P51-S5 / S9: an error message in the screen's language — Arabic: the server's detail_ar, else the coded
// translation, else the Arabic fallback (never the English detail); English: the server's detail, else the fallback.
export function errText(err, lang, fallback) {
  const kept = typedKeptMessage(err, lang === "ar" ? "ar" : "en");   // Step 12 add-on G6.1: Cancel of the typed-amount confirm
  if (kept) return kept;
  const d = err?.response?.data || {};
  const code = typeof d.error_code === "string" ? d.error_code : "";
  if (lang === "ar") {
    if (d.detail_ar) return d.detail_ar;
    return (code && I18N_B34G.ar.errors[code]) || fallback;
  }
  return (typeof d.detail === "string" && d.detail) || fallback;
}

export default I18N_B34G;
